import { render } from "./CategoryMenuItemButton.vue?vue&type=template&id=1370ba51&scoped=true"
import script from "./CategoryMenuItemButton.vue?vue&type=script&lang=js"
export * from "./CategoryMenuItemButton.vue?vue&type=script&lang=js"

import "./CategoryMenuItemButton.vue?vue&type=style&index=0&id=1370ba51&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1370ba51"]])

export default __exports__